import { Contest, ContestEntry } from "interfaces/leaderboard/contest";
import { CONTEST_STATE } from "utils/constants";

/**
 * Checks if a user can enter a contest based on contest state and entry limits
 */
export const checkIfUserCanEnterContest = (
  contest: Contest,
  userEntries: ContestEntry[] = []
): boolean => {
  const userEntryCount = userEntries.length;

  // Contest must be open
  const isContestOpen = contest.state === CONTEST_STATE.OPEN;

  // Contest must not have reached its maximum entries
  const isContestNotFull = !contest.max_entries ||
    contest.total_entries < contest.max_entries;

  // User must not have reached their maximum entries
  const isUserEntriesNotFull = !contest.max_entries_per_user ||
    userEntryCount < contest.max_entries_per_user;

  // User can enter if all conditions are met
  return isContestOpen && isContestNotFull && isUserEntriesNotFull;
};